export function clearValidationErrors() {
  document.getElementById("validation-notifications")?.replaceChildren()
}

export function showValidationError(message) {
  const template = document.getElementById("error-notification-template")
  const container = document.getElementById("validation-notifications")
  if (!template || !container) return

  const notification = template.content.cloneNode(true)
  notification.querySelector("[data-notification-message]").textContent = message
  container.replaceChildren(notification)
}
